import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { firstValueFrom, forkJoin } from 'rxjs';
import { CustomerSupportService } from '../customer-support/services/customer-support.service';
import { SecurityService } from '../shared/security.service';

@Component({
    selector: 're-after-login-blank',
    templateUrl: './after-login-blank.component.html',
    styleUrls: ['./after-login-blank.component.scss'],
    standalone: false
})
export class AfterLoginBlankComponent implements OnInit {

  constructor(private router: Router, private securityService: SecurityService, private customerSupportService: CustomerSupportService) { }

  async ngOnInit() {

    let isViewCustomer = await firstValueFrom(this.securityService.isCanViewAnyCustomer())
    if (isViewCustomer) {
      this.router.navigate(["/customer-selection"]);
    }
    else {
      this.securityService.navigateToHome();
    }
  }

}
